import { getQuarter } from 'date-fns';
import { createContext, useState } from 'react';

export type Period = {
    quarter: number;
    year: number;
};

export const PeriodContext = createContext({
    period: {
        quarter: 0,
        year: 0,
    },
    decreaseQuarter: () => {},
    increaseQuarter: () => {},
    isCurrentQuarter: false,
});

export const PeriodProvider = ({ children }: { children: React.ReactNode }) => {
    const [period, setPeriod] = useState({ quarter: getQuarter(new Date()), year: new Date().getFullYear() });
    const isCurrentQuarter = period.quarter === getQuarter(new Date()) && period.year === new Date().getFullYear();

    const decreaseQuarter = () => {
        if (period.quarter === 1) {
            setPeriod({ quarter: 4, year: period.year - 1 });
        } else {
            setPeriod({ quarter: period.quarter - 1, year: period.year });
        }
    };

    const increaseQuarter = () => {
        if (period.quarter === getQuarter(new Date()) && period.year === new Date().getFullYear()) {
            return;
        }

        if (period.quarter === 4) {
            setPeriod({ quarter: 1, year: period.year + 1 });
        } else {
            setPeriod({ quarter: period.quarter + 1, year: period.year });
        }
    };

    return <PeriodContext.Provider value={{ period, isCurrentQuarter, decreaseQuarter, increaseQuarter }}>{children}</PeriodContext.Provider>;
};
